import { Int } from '@adornis/baseql/baseqlTypes.js';
import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { watchQuery } from '@adornis/baseql/server/watchQuery.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { of, type Observable } from 'rxjs';
import { getCurrentUserID } from '../../../api/currentUserID.js';
import {
  NOTIFICATION_DONE_STATES,
  NOTIFICATION_OPEN_STATES,
  UserNotification,
} from '../db/UserNotification.js';

/**
 * The caller's own notifications, live. The recipient filter is built **server-side** from
 * the session — the client never passes a user id, and `publishFilter` is empty in this app,
 * so this resolver is the only thing standing between one user's inbox and another's.
 */
export const subscribeMyNotifications = registerSubscription({
  type: () => [UserNotification],
  operationName: 'subscribeMyNotifications',
  resolve: (showDone: boolean, skip: number, limit: number) => {
    return (_gqlFields: BaseQLSelectionSet<UserNotification>): Observable<UserNotification[]> => {
      const userID = getCurrentUserID();
      if (!userID) return of([]);

      return watchQuery<UserNotification>(
        UserNotification._collectionName,
        { recipientUserID: userID, status: { $in: showDone ? NOTIFICATION_DONE_STATES : NOTIFICATION_OPEN_STATES } },
        { skip, limit, sort: { createdAt: -1 } },
      );
    };
  },
  params: [
    { name: 'showDone', type: () => Boolean },
    { name: 'skip', type: () => Int },
    { name: 'limit', type: () => Int },
  ],
});
